<template>
    <div>
        <header class="bg-white">
            <div class="header-slider bg-black header-slider_first" style="background-image: url('/static/slider2.png');">
                <div class="container">
                    <div class="header-slider-header">
                        <div class="logo-box">
                            <a :href="`${$t('meta.home.homeToUrl')}`">
                                <img
                                    src="~img/logo-white-white.png"
                                    :alt="$t('meta.home.h1')"
                                    :title="$t('meta.home.title') + ' | ' + hostname">
                            </a>
                        </div>
                    </div>
                    <div class="header-slider-body">
                        <b-carousel id="carouselExampleIndicators"
                                    class="carousel slide"
                                    controls
                                    indicators
                                    :interval="6000"
                                    @sliding-start="onSlideStart"
                                    @sliding-end="onSlideEnd">
                            <b-carousel-slide class="carousel-item h-650">
                                <div class="carousel-item-content">
                                    <div class="text-small">{{$t("public.home.services")}} 1/4</div>
                                    <h2 class="text-title">{{$t("public.home.slider[0].title")}}</h2>
                                    <p class="text-text">{{$t("public.home.slider[0].text")}}</p>
                                    <div class="button-wrapper">
                                        <router-link
                                            class="btn btn-accent"
                                            tag="a"
                                            :to="{name: 'AdditionalService'}">{{$t("public.home.slider[0].btn")}}</router-link>
                                        <!-- TODO: Waiting to video -->
                                        <a href="#" class="carousel-item-link d-none">
                                            <i class="icon-youtube-play"></i>
                                            peržiūrėti
                                        </a>
                                    </div>
                                </div>
                                <div class="img-wrapper img-wrapper_b20">
                                    <img class="d-block w-100" src="~img/header-slide-1.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                </div>
                            </b-carousel-slide>
                            <b-carousel-slide class="carousel-item h-650">
                                <div class="carousel-item-content">
                                    <div class="text-small">{{$t("public.home.services")}} 2/4</div>
                                    <h2 class="text-title">{{$t("public.home.slider[1].title")}}</h2>
                                    <p class="text-text">{{$t("public.home.slider[1].text")}}</p>
                                    <div class="button-wrapper">
                                        <router-link
                                            class="btn btn-accent"
                                            tag="a"
                                            :to="{name: 'Integration'}">{{$t("public.home.slider[1].btn")}}</router-link>
                                        <!-- TODO: Waiting to video -->
                                        <a href="#" class="carousel-item-link d-none">
                                            <i class="icon-youtube-play"></i>
                                            peržiūrėti
                                        </a>
                                    </div>
                                </div>
                                <div class="img-wrapper img-wrapper_b20">
                                    <img class="d-block w-100" src="~img/header-slide-1.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                </div>
                            </b-carousel-slide>
                            <b-carousel-slide class="carousel-item h-650">
                                <div class="carousel-item-content">
                                    <div class="text-small">{{$t("public.home.services")}} 3/4</div>
                                    <h2 class="text-title">{{$t("public.home.slider[2].title")}}</h2>
                                    <p class="text-text">{{$t("public.home.slider[2].text")}}</p>
                                    <div class="button-wrapper">
                                        <router-link
                                            class="btn btn-accent"
                                            tag="a"
                                            :to="{name: 'AdditionalService'}">{{$t("public.home.slider[2].btn")}}</router-link>
                                        <!-- TODO: Waiting to video -->
                                        <a href="#" class="carousel-item-link d-none">
                                            <i class="icon-youtube-play"></i>
                                            peržiūrėti
                                        </a>
                                    </div>
                                </div>
                                <div class="img-wrapper img-wrapper_b20">
                                    <img class="d-block w-100" src="~img/header-slide-1.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                </div>
                            </b-carousel-slide>
                            <b-carousel-slide class="carousel-item h-650">
                                <div class="carousel-item-content">
                                    <div class="text-small">{{$t("public.home.services")}} 4/4</div>
                                    <h2 class="text-title">{{$t("public.home.slider[3].title")}}</h2>
                                    <p class="text-text">{{$t("public.home.slider[3].text")}}</p>
                                    <div class="button-wrapper">
                                        <router-link
                                            class="btn btn-accent"
                                            tag="a"
                                            :to="{name: 'AdditionalService'}">{{$t("public.home.slider[3].btn")}}</router-link>
                                        <!-- TODO: Waiting to video -->
                                        <a href="#" class="carousel-item-link d-none">
                                            <i class="icon-youtube-play"></i>
                                            peržiūrėti
                                        </a>
                                    </div>
                                </div>
                                <div class="img-wrapper img-wrapper_b20">
                                    <img class="d-block w-100" src="~img/header-slide-1.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                </div>
                            </b-carousel-slide>
                        </b-carousel>
                    </div>
                </div>
            </div>
            <div class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <div class="frame bg-white">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <h1 class="frame-title">{{$t('meta.home.h1')}}</h1>
                        <!-- TODO Waiting for video -->
                        <div class="iframe-responsive d-none">
                            <iframe width="100%"
                                    height="auto"
                                    src="https://www.youtube.com/embed/2ccaHpy5Ewo?ecver=1"
                                    frameborder="0"
                                    allow="autoplay; encrypted-media"
                                    allowfullscreen></iframe>
                        </div>
                        <span class="frame-text">{{$t("public.home.services_3pl.text")}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="partnerial-wrap">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="partnerial-item">
                            <ul class="partnerial-item-nav partnerial-item-nav_grey">
                                <li>
                                    <router-link tag="a" :to="{name: 'Integration'}">
                                        <img src="~img/brand/amazon-grey.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                    </router-link>
                                </li>
                                <li>
                                    <router-link tag="a" :to="{name: 'Integration'}">
                                        <img src="~img/brand/ebay-gray.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                    </router-link>
                                </li>
                                <li>
                                    <router-link tag="a" :to="{name: 'Integration'}">
                                        <img src="~img/brand/shopify-gray.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="partnerial-item">
                            <ul class="partnerial-item-nav partnerial-item-nav_grey mb-3 flex-wrap">
                                <li class="mb-3">
                                    <router-link tag="a" :to="{name:'Partnerial'}">
                                        <img src="~img/partners7.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')" style="max-width: 100px">
                                    </router-link>
                                </li>
                                <li class="mb-3">
                                    <router-link tag="a" :to="{name:'Partnerial'}">
                                        <img src="~img/partners19.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                    </router-link>
                                </li>
                                <li class="mb-3">
                                    <router-link tag="a" :to="{name:'Partnerial'}">
                                        <img src="~img/partners14.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="partnerial-item" v-if="false">
                            <ul class="partnerial-item-nav partnerial-item-nav_grey mb-3 flex-wrap">
                                <li class="mb-3">
                                    <router-link tag="a" :to="{name:'Partnerial'}">
                                        <img src="~img/partners10.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                    </router-link>
                                </li>
                                <li class="mb-3">
                                    <router-link tag="a" :to="{name:'Partnerial'}">
                                        <img src="~img/partners18.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')" style="max-width: 80px">
                                    </router-link>
                                </li>
                                <li class="mb-3">
                                    <router-link tag="a" :to="{name:'Partnerial'}">
                                        <img src="~img/partners14.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                    </router-link>
                                </li>
                                <li class="mb-3">
                                    <router-link tag="a" :to="{name:'Partnerial'}">
                                        <img src="~img/partners16.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                    </router-link>
                                </li>
                            </ul>
                            <ul class="partnerial-item-nav partnerial-item-nav_grey mb-3 flex-wrap">
                                <li class="mb-3">
                                    <router-link tag="a" :to="{name:'Partnerial'}">
                                        <img src="~img/partners15.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                    </router-link>
                                </li>
                                <li class="mb-3">
                                    <router-link tag="a" :to="{name:'Partnerial'}">
                                        <img src="~img/partners7.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')" style="max-width: 100px">
                                    </router-link>
                                </li>
                                <li class="mb-3">
                                    <router-link tag="a" :to="{name:'Partnerial'}">
                                        <img src="~img/brand/dhl-gray.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                    </router-link>
                                </li>
                                <li>
                                    <router-link tag="a" :to="{name:'Partnerial'}">
                                        <img src="~img/brand/tnt-gray.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                    </router-link>
                                </li>
                                <li>
                                    <router-link tag="a" :to="{name:'Partnerial'}">
                                        <img src="~img/brand/omniva-gray.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                    </router-link>
                                </li>
                                <li>
                                    <router-link tag="a" :to="{name:'Partnerial'}">
                                        <img src="~img/brand/venipack-gray.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section class="half half_white">
            <div class="container">
                <div class="row">
                    <div class="col-xl-6">
                        <div class="half-text">
                            <span class="half-text-small">{{$t("public.home.services")}} 1/3</span>
                            <h2 class="half-text-title">{{$t("public.home.benefits[0].title")}}</h2>
                            <span class="half-text-text">{{$t("public.home.benefits[0].text")}}</span>
                            <router-link
                                class="half-text-link"
                                tag="a"
                                :to="{name: 'Advantages'}">{{$t("public.home.benefits[0].btn")}}</router-link>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <div class="half-img half-img_center">
                            <img src="~img/half2.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="half half_red">
            <div class="container">
                <div class="row">
                    <div class="col-xl-6">
                        <div class="half-text">
                            <span class="half-text-small">{{$t("public.home.services")}} 2/3</span>
                            <h2 class="half-text-title">{{$t("public.home.benefits[1].title")}}</h2>
                            <span class="half-text-text">{{$t("public.home.benefits[1].text")}}</span>
                            <router-link
                                class="half-text-link"
                                tag="a"
                                :to="{name: 'Integration'}">{{$t("public.home.benefits[1].btn")}}</router-link>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <div class="half-img half-img_large">
                            <img src="~img/half1.jpg" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="back-img center-style back-img_2">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <h3 class="center-style-title" v-html="$t('public.home.benefits[2].title')"></h3>
                        <div class="row align-items-center justify-content-center mt-3">
                            <div class="col-6 col-lg-3"><a href="tel:+157 1245 9841" class="btn btn-primary-user w-100">+157 1245 9841</a></div>
                            <div class="col-6 col-lg-3"><a href="mailto:info@boxiti.com" class="btn btn-primary-user w-100">info@boxiti.com</a></div>
                        </div>
                        <router-link
                                class="center-style-link"
                                tag="a"
                                :to="{name: 'Contacts'}">{{$t("public.home.benefits[2].btn")}}</router-link>
                    </div>
                </div>
            </div>
        </section>

        <section class="half half_yellow">
            <div class="container">
                <div class="row">
                    <div class="col-xl-6">
                        <div class="half-text">
                            <span class="half-text-small">{{$t("public.home.services")}} 3/3</span>
                            <h2 class="half-text-title">{{$t("public.home.benefits[3].title")}}</h2>
                            <span class="half-text-text">{{$t("public.home.benefits[3].text")}}</span>
                            <router-link
                                class="half-text-link"
                                tag="a"
                                :to="{name: 'Advantages'}">{{$t("public.home.benefits[3].btn")}}</router-link>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <div class="half-img half-img_small">
                            <img src="~img/half1.jpg" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <priorities-carousel></priorities-carousel>

        <div class="comments">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="comments-item">
                            <div class="comments-item-img">
                                <img src="~img/comment1.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                            </div>
                            <h3 class="comments-item-title">{{$t("public.home.reviews.comments[0].name")}}</h3>
                            <span class="comments-item-text">{{$t("public.home.reviews.comments[0].text")}}</span>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="comments-item">
                            <div class="comments-item-img">
                                <img src="~img/comment2.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                            </div>
                            <h3 class="comments-item-title">{{$t("public.home.reviews.comments[1].name")}}</h3>
                            <span class="comments-item-text">{{$t("public.home.reviews.comments[1].text")}}</span>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="comments-item">
                            <div class="comments-item-img">
                                <img src="~img/comment3.png" :alt="$t('meta.home.h1')"  :title="$t('meta.home.h1')">
                            </div>
                            <h3 class="comments-item-title">{{$t("public.home.reviews.comments[2].name")}}</h3>
                            <span class="comments-item-text">{{$t("public.home.reviews.comments[2].text")}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <try-it-section></try-it-section>

        <footer-component></footer-component>
    </div>
</template>

<script>
    import PrioritiesCarousel from '~cp/PrioritiesCarousel.vue'
    import TryItSection from '~cp/Public/PublicComponets/TryItSection.vue'

    export default {
        name: 'Home',
        components: {
            PrioritiesCarousel,
            TryItSection
        },
        data() {
            return {
                sliding: null,
                hostname: window.location.hostname
            }
        },
        metaInfo() {
            return {
                title: this.$t('meta.home.title'),
                meta: [
                    { vmid: 'description', name: 'description', content: this.$t('meta.home.description') },
                ]
            }
        },
        methods: {
            onSlideStart(slide) {
                this.sliding = true
            },
            onSlideEnd(slide) {
                this.sliding = false
            }
        }
    }
</script>

<style lang="scss">
    header .header-slider {
        margin-bottom: 10px;
        .carousel-inner {
            .img-wrapper {
                bottom: 45px;
            }
        }
    }
    .frame {
        padding-top: 45px;
        padding-bottom: 30px;
    }
    .frame-title {
        font-size: 30px;
    }
    footer {
        padding-top: 25px;
    }

    @media (min-width: 992px) {
        .frame-title {
            font-size: 30/16*15px;
        }
    }
    @media (max-width: 575.98px) {
        .frame-title {
            font-size: 30/16*12px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Public/Home.vue